"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactScrollToBottom = require("react-scroll-to-bottom");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _useActivities3 = _interopRequireDefault(require("../hooks/useActivities"));

var _useDirection3 = _interopRequireDefault(require("../hooks/useDirection"));

var _useFocusSendBox = _interopRequireDefault(require("../hooks/useFocusSendBox"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

var _useScrollToEnd = _interopRequireDefault(require("../hooks/useScrollToEnd"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ScrollToEndButton = function ScrollToEndButton(_ref) {
  var animating = _ref.animating,
      className = _ref.className,
      sticky = _ref.sticky;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      scrollToEndButtonStyleSet = _useStyleSet2[0].scrollToEndButton;

  var _useActivities = (0, _useActivities3.default)(),
      _useActivities2 = _slicedToArray(_useActivities, 1),
      activities = _useActivities2[0];

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var focusSendBox = (0, _useFocusSendBox.default)();
  var localize = (0, _useLocalizer.default)();
  var scrollToEnd = (0, _useScrollToEnd.default)();
  var handleClick = (0, _react.useCallback)(function () {
    scrollToEnd();
    focusSendBox();
  }, [focusSendBox, scrollToEnd]);
  var newMessageText = localize('TRANSCRIPT_NEW_MESSAGES'); // Ignore activity types other than "message"

  var lastMessageActivity = _toConsumableArray(activities).reverse().find(function (_ref2) {
    var type = _ref2.type;
    return type === 'message';
  });

  var lastShownActivityId = (lastMessageActivity || {}).id;
  var lastReadActivityIdRef = (0, _react.useRef)(lastShownActivityId);
  var lastReadActivityId = lastReadActivityIdRef.current;

  if (sticky) {
    // If it is sticky, mark the activity ID as read.
    lastReadActivityIdRef.current = lastShownActivityId;
  } // Don't show the button if:
  // - The scroll bar is animating
  //   - Otherwise, this will cause a flashy button when: 1. Scroll to top, 2. Send something, 3. The button flashes when it is scrolling down
  // - It is already at the bottom (sticky)
  // - The last activity ID has been read


  if (animating || sticky || lastShownActivityId === lastReadActivityId) {
    return false;
  }

  return _react.default.createElement("button", {
    className: (0, _classnames.default)('webchat__scrollToEndButton', scrollToEndButtonStyleSet + '', className + '', direction === 'rtl' ? 'webchat__overlay--rtl' : ''),
    onClick: handleClick,
    type: "button"
  }, newMessageText);
};

ScrollToEndButton.defaultProps = {
  className: ''
};
ScrollToEndButton.propTypes = {
  animating: _propTypes.default.bool.isRequired,
  className: _propTypes.default.string,
  sticky: _propTypes.default.bool.isRequired
};

var ConnectedScrollToEndButton = function ConnectedScrollToEndButton(props) {
  return _react.default.createElement(_reactScrollToBottom.StateContext.Consumer, null, function (_ref3) {
    var animating = _ref3.animating,
        sticky = _ref3.sticky;
    return _react.default.createElement(ScrollToEndButton, _extends({
      animating: animating,
      sticky: sticky
    }, props));
  });
};

var _default = ConnectedScrollToEndButton;
exports.default = _default;